import {Board} from '@extensions/board'
import {Lang} from 'yougile-lang'
import {Hub} from 'yougile-model'

export const getOrCreateColumn = (title: string, board: Hub): Hub => {
  const columnName = title || Lang.msg.importFromFile.otherTasks

  const columns = Board.listColumns(board)
  const column = columns.find(c => c.title === columnName)

  return column || Board.addColumn(columnName, board)
}
